import React, { useMemo } from 'react';
import BookCard from './BookCard';
import './RecentlyAddedBooks.css';

function RecentlyAddedBooks({ books, limit = 6 }) {
  const recentBooks = useMemo(() => {
    return books
      .sort((a, b) => {
        const dateA = a.createdAt?.seconds || 0;
        const dateB = b.createdAt?.seconds || 0;
        return dateB - dateA;
      })
      .slice(0, limit);
  }, [books, limit]);

  const getTimeAgo = (createdAt) => {
    if (!createdAt?.seconds) return 'Recently';
    
    const now = new Date();
    const bookDate = new Date(createdAt.seconds * 1000);
    const diffInHours = Math.floor((now - bookDate) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${diffInHours}h ago`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) return `${diffInDays}d ago`;
    
    const diffInWeeks = Math.floor(diffInDays / 7);
    if (diffInWeeks < 4) return `${diffInWeeks}w ago`;
    
    const diffInMonths = Math.floor(diffInDays / 30);
    return `${diffInMonths}mo ago`;
  };

  if (recentBooks.length === 0) {
    return (
      <div className="recently-added-books">
        <div className="section-header">
          <h2>📚 Recently Added</h2>
          <p>Books you've added to your library</p>
        </div>
        <div className="empty-recent">
          <div className="empty-icon">📖</div>
          <p>No books added yet. Start building your library!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="recently-added-books">
      <div className="section-header">
        <h2>📚 Recently Added</h2>
        <p>Latest additions to your library</p>
      </div>
      
      <div className="recent-books-grid">
        {recentBooks.map(book => (
          <div key={book.id} className="recent-book-item">
            <BookCard book={book} />
            <div className="recent-book-meta">
              <span className="added-time">{getTimeAgo(book.createdAt)}</span>
              <div className="book-status-indicator">
                <span className={`status-dot ${(book.readingStatus || book.status)}`}></span>
                <span className="status-text">
                  {(book.readingStatus || book.status) === 'toRead' ? 'To Read' : 
                   (book.readingStatus || book.status) === 'reading' ? 'Reading' : 
                   (book.readingStatus || book.status) === 'finished' ? 'Finished' : 'Unknown'}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {books.length > limit && (
        <div className="view-all-section">
          <button className="view-all-btn">
            View All {books.length} Books →
          </button>
        </div>
      )}
    </div>
  );
}

export default RecentlyAddedBooks;